/* cm-contact.js — CasMarkt contact page (DESIGN-v1.6 item 11)
   Loaded from sections/cm-contact.liquid. Progressive enhancement only:
   without it the form still submits, the maxlength attributes still cap the
   input and the honeypot is simply ignored.
   - live character counter on the message ("0 / 1000", pink near the cap)
   - honeypot + dwell-time check so scripted spam never reaches the inbox
   - a busy state on the submit button so nobody double-sends
   No libraries, no motion beyond what CSS already declares. */
(function () {
  'use strict';

  var MIN_DWELL_MS = 1800; // scripted posts land in well under a second

  function each(root, selector, fn) {
    var nodes = (root || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }

  // The flag lives in its own data-* name: reusing an attribute the markup
  // already carries (data-cm-counter) would overwrite the value we need.
  function claim(el, key) {
    var flag = 'cmInit' + key;
    if (el.dataset[flag] === '1') return false;
    el.dataset[flag] = '1';
    return true;
  }

  /* --- live character counter ------------------------------------------- */
  function initCounters(root) {
    each(root, '[data-cm-counter]', function (field) {
      if (!claim(field, 'Counter')) return;

      var output = document.getElementById(field.getAttribute('data-cm-counter'));
      if (!output) return;

      var max = parseInt(field.getAttribute('maxlength'), 10) || 1000;
      var warn = parseInt(field.getAttribute('data-cm-counter-warn'), 10) || max;

      var update = function () {
        var len = field.value.length;
        output.textContent = len + ' / ' + max;
        output.classList.toggle('is-near', len >= warn && len < max);
        output.classList.toggle('is-max', len >= max);
      };

      field.addEventListener('input', update);
      update();
    });
  }

  /* --- spam guards + submit state --------------------------------------- */
  function initForms(root) {
    each(root, 'form.cm-contact__form', function (form) {
      if (!claim(form, 'ContactForm')) return;

      var opened = Date.now();
      var pot = form.querySelector('[data-cm-honeypot]');
      var button = form.querySelector('.cm-contact__submit');

      var released = false;

      form.addEventListener('submit', function (event) {
        // A filled honeypot is a script, not a customer: drop it silently.
        if (pot && pot.value.trim() !== '') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        // An instant submit is also a script. A real person is never punished
        // for it: the send is held for the remainder of the window and then
        // goes through on its own, so nobody sees a dead button.
        var waited = Date.now() - opened;
        if (!released && waited < MIN_DWELL_MS) {
          event.preventDefault();
          window.setTimeout(function () {
            released = true;
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }, MIN_DWELL_MS - waited);
          return;
        }

        // Let the browser's own validation message win before we lock the button.
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

        if (button) {
          button.classList.add('is-busy');
          button.setAttribute('aria-busy', 'true');
          var label = button.querySelector('.cm-contact__submit-label');
          if (label) label.textContent = 'Sending…';
        }
      });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initCounters(scope);
    initForms(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor swaps the section in without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
